import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_de8f5way8k: FaireBrandEntity = {
  token: "b_de8f5way8k",
  type: "brand",
  name: "Rock Paradise",
  avatarUrl:
    "https://cdn.faire.com/fastly/f28dbb42094a073d5bcf88481c3c8b38a3b05f8507161060a6467d2d8f7a6306.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/541bb457ddf905014a8c8e03b18f780897ff0cc13f154971f5c8f05f91d1b025.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f28dbb42094a073d5bcf88481c3c8b38a3b05f8507161060a6467d2d8f7a6306.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/541bb457ddf905014a8c8e03b18f780897ff0cc13f154971f5c8f05f91d1b025.png",
  location: "Canoga Park, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 785,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Rock Paradise, your source for Natural stone products. We travel the world working with mines directly. Highest Quality with the Best Deals around! We look forward to working with you. Feel free to ask questions or make custom requests. Customer service is our priority! All items ship from the USA! That means low prices without high fees for importing! We work with cutters and mines around the world and can manufacturer just about any stone product for home decor, jewelry, meditation practices, and resale. We can do private label work for your jewelry or home decor line. Email us to find out more about our manufacturing and wholesale pricing. We can provide our items in bulk at amazing pricing.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:22.903Z",
    importedBy: "entity-db-cli",
  },
};
